import { RouteLocation, Router } from 'vue-router';

export const backToBlocklyPage = (route: RouteLocation, router: Router) => {
  console.log('back', route);
  const project_id = route.params.project_id as string;
  router.push({ name: 'BlocklyPage', params: { proejct_id: project_id } });
};
